//* warehouses id

export const WH_ESTUDIONUBE_ID = 1695;
export const WH_ESTRADA_ID = 1;
export const WH_TOM_ID = 1974;

//? query keys
export const WAREHOUSES_QUERY_KEYS = {
  all: ["warehouses"],
  lists: () => [...WAREHOUSES_QUERY_KEYS.all, "list"],
  list: (filters) => [...WAREHOUSES_QUERY_KEYS.lists(), filters],
};

//? warehouses name
export const WAREHOUSES_NAME = {
  [WH_ESTRADA_ID]: "Shipnow Estrada",
  [WH_ESTUDIONUBE_ID]: "Estudio Nube",
  [WH_TOM_ID]: "Estudio Nube",
};
